export const useData = (): string[] => [
	'Educational course to form healthy habits and maintain weight',
	'One-on-one guidance from a supportive coach*',
	'Calorie balance tailored to you for effective weight loss',
	'Food logging with 1 million+ items in our database',
	'Access to a vast collection of chef-designed recipes',
	'Various workout programs to be more active and fit',
	'Connect with Health App to help yourself stay on top of trends in your activity progress',
];

export const useDataV2 = (): string[] => [
	'Educational course to form healthy habits and maintain weight',
	'Calorie balance tailored to you for effective weight loss',
	'Food logging with 1 million+ items in our database',
	'Access to a vast collection of chef-designed recipes',
	'Various workout programs to be more active and fit',
	'Connect with Health App to help yourself stay on top of trends in your activity progress',
];
